// extracted by mini-css-extract-plugin
module.exports = {"bopPolicyChangeWizardContainer":"BOPPolicyChangeWizard_bopPolicyChangeWizardContainer__2vnNr"};